import getRandomString from "src/helpers/getRandomString";
import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

interface CurrentAudio {
	id: string;
	audioUrl: string;
	thumbnailUrl: string;
}
export interface AudioPlayerStore {
	status: "playing" | "paused";
	currentAudio: CurrentAudio | null;
	subscriptions: CurrentAudio[];
	createAudio: (audio: Omit<CurrentAudio, "id">) => () => void;
	setStatus: (status: "playing" | "paused") => void;
	clear: () => void;
}
const initialState: Pick<AudioPlayerStore, "status" | "currentAudio" | "subscriptions"> = {
	status: "playing",
	currentAudio: null,
	subscriptions: [],
};

const useAudioPlayerStore = create<AudioPlayerStore>()(
	subscribeWithSelector((set) => ({
		...initialState,
		createAudio: (audio) => {
			const id = getRandomString(16);
			const newAudio = {
				id,
				...audio,
			};
			set((state) => {
				const newSubscriptions = [...state.subscriptions, newAudio];
				const newCurAudio = newSubscriptions[0];
				if (
					newCurAudio &&
					(!state.currentAudio || newCurAudio.id !== state.currentAudio?.id)
				) {
					return {
						currentAudio: newCurAudio,
						subscriptions: newSubscriptions,
					};
				} else {
					return {
						subscriptions: newSubscriptions,
					};
				}
			});
			return () => {
				set((state) => {
					const newSubscriptions = state.subscriptions.filter((s) => s.id !== id);
					const newCurAudio = newSubscriptions[0];
					if (!newCurAudio) {
						return {
							currentAudio: null,
							subscriptions: newSubscriptions,
						};
					} else if (newCurAudio && newCurAudio.id !== state.currentAudio?.id) {
						return {
							currentAudio: newCurAudio,
							subscriptions: newSubscriptions,
						};
					} else {
						return {
							subscriptions: newSubscriptions,
						};
					}
				});
			};
		},
		setStatus: (status) => set(() => ({ status })),
		clear: () => set(() => ({ subscriptions: [], currentAudio: null })),
	})),
);

export default useAudioPlayerStore;
